module.exports = __webpack_public_path__ + "img/popupAd-day11.a2ca0289.png";